import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { reject } from 'q';

@Injectable()
export class TokenVerificationService {

  constructor(private http: HttpClient) { }

  public Get(eventKey: string, token: string): Promise<Date> {
    return this.http.get<string>(`/api/registration/v1/token/${eventKey}/${token}`).toPromise()
      .then((result) => {
        return new Date(result);
      })
      .catch((reason) => {
        if (reason.status === 404) {
          return null;
        } else {
          return Promise.reject('Token not found');
        }
      });
  }

  public Validate(eventKey: string, token: string): Observable<void> {
    return this.http.post<void>(`/api/registration/v1/token/${eventKey}/${token}`, token);
  }
}
